import React from "react";

import { Helmet } from "react-helmet";

import { MARKETING_OSTRIO_BEACON_URL, MARKETING_OSTRIO_ID } from "@/marketing/constants";

/**
 * Трекер веб-аналитики ostr.io. И скрипт трекера, и беакон идут через наш домен
 * (`MARKETING_OSTRIO_BEACON_URL`), а не через analytics.ostr.io: иначе блокировщики
 * режут скрипт и статистика теряется.
 *
 * Сниппет написан вручную, а не взят у вендора: он умеет только относительный
 * `serviceUrl`, а фронт и API живут на разных хостах.
 */
const OstrioAnalyticsHelmet = () => {
  if (!MARKETING_OSTRIO_ID || !MARKETING_OSTRIO_BEACON_URL) return null;

  return (
    <Helmet>
      <script type="text/javascript">
        {`(function(d, t, u, i) {
// Guard от двойной инициализации: при SSR + гидрации react-helmet может выполнить
// этот инлайн-скрипт повторно.
if (window.__ostrioInitialized) { return; }
window.__ostrioInitialized = true;

var s = d.createElement(t), f = d.getElementsByTagName(t)[0];
s.async = 1;
s.src = u + "t.js";
s.onload = function() {
  if (typeof OstrioTrackerClass !== "function") { return; }
  window.ostrioTracker = new OstrioTrackerClass(i, {
    serviceUrl: u,
    transport: "fetch",
    auto: true,
    // Тексты JS-исключений содержат текущий URL, и настройки очистки query на них
    // не действуют — это отдельный канал утечки.
    trackErrors: false,
    ignoredQueries: ["token", "password", "email", "phone", "code", "hash", "promocode", "sessionid"]
  });
};
f.parentNode.insertBefore(s, f);
})(document, "script", "${MARKETING_OSTRIO_BEACON_URL}", "${MARKETING_OSTRIO_ID}");`}
      </script>
    </Helmet>
  );
};

export default OstrioAnalyticsHelmet;
